export class Constant {
  static GOOGLE_MAPS_LIBRARIES = ["places"];
  static GOOGLE_MAPS_KEY = "AIzaSyAbKHd3D0sMt_YI5175r284Oa6xPZh_83A";
  static PAY_STACK_KEY = "Bearer sk_test_56fd5ef875ef518ad85c3ecf99d5a9b28727f1df";
}
